import { PUBLIC_URL } from '../../utils/constants';

export default {
  // Doctor
  HEALTHCARE_MODULE_DOCTORS_LISTING: `${PUBLIC_URL}/healthcare/doctors/list`,
  HEALTHCARE_MODULE_ADD_DOCTOR: `${PUBLIC_URL}/healthcare/doctor/add`,
  HEALTHCARE_MODULE_EDIT_DOCTOR: `${PUBLIC_URL}/healthcare/doctor/edit/:id`,
  HEALTHCARE_MODULE_DOCTOR_DETAILS: `${PUBLIC_URL}/healthcare/doctor/details/:id`,

  // Healthcare
  HEALTHCARE_MODULE_HEALTH_CARE_LISTING: `${PUBLIC_URL}/healthcare/healthcareFacility/list`,
  HEALTHCARE_MODULE_ADD_HEALTH_CARE: `${PUBLIC_URL}/healthcare/healthcareFacility/add`,
  HEALTHCARE_MODULE_EDIT_HEALTH_CARE: `${PUBLIC_URL}/healthcare/healthcarFacility/edit/:id`,
  HEALTHCARE_MODULE_HEALTHCARE_DETAILS: `${PUBLIC_URL}/healthcare/healthcareFacility/details/:id`,
  HEALTHCARE_MODULE_CLINIC_LISTING: `${PUBLIC_URL}/healthcare/doctors/clinic/list`,
  HEALTHCARE_MODULE_ADD_CLINIC: `${PUBLIC_URL}/healthcare/doctor/:doctorId/clinic/add`,
  HEALTHCARE_MODULE_EDIT_CLINIC: `${PUBLIC_URL}/healthcare/doctor/:doctorId/clinic/edit/:id`,

  // Medicines
  MEDICINES_LISTING: `${PUBLIC_URL}/healthcare/medicines/list`,
  ADD_MEDICINE: `${PUBLIC_URL}/healthcare/medicine/add`,
  EDIT_MEDICINE: `${PUBLIC_URL}/healthcare/medicine/edit/:id`,
};
